<template>
  <div class="v-modal-content no-inner-margin">
    <div class="modal-header">
      <h3 v-if="title" class="modal-title v-modal-content__title">{{title}}</h3>
        <button class="btn btn--cancel cancel" type="button" v-on:click="close">x</button>
    </div>
    <div class="v-modal-content__content"><slot></slot></div>
    <div class="v-modal-content__buttons"><slot name="buttons"></slot></div>
  </div>
</template>

<script>
export default {
  props: ['title'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style>
</style>
